module.exports = __webpack_public_path__ + "static/media/Logipark.d8a3cb16.png";